<input
  type="date"
  class="form-control"
  [placeholder]="question.placeholder"
  [id]="question.key"
  [min]="question.payload"
  [formControlName]="question.key"
  [required]="question.required"
/>
